// Avatar.jsx
// Avatar de pessoa com fallback pra iniciais + gradient determinístico pelo id/nome
// Uso: <Avatar nome="Hugo Quaresma" id={12} size={36} fotoUrl="..." />

const GRADIENTS = [
  ['#F15D22', '#FEBA12'],   // laranja → amarelo
  ['#673091', '#F15D22'],   // roxo → laranja
  ['#16A34A', '#F15D22'],   // verde → laranja
  ['#F15D22', '#673091'],   // laranja → roxo
  ['#FEBA12', '#F15D22'],   // amarelo → laranja
  ['#673091', '#16A34A'],   // roxo → verde
  ['#F15D22', '#16A34A'],   // laranja → verde
  ['#3B82F6', '#673091'],   // azul → roxo
];

function iniciais(nome) {
  if (!nome) return '?';
  const parts = nome.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

function gradientFromId(id) {
  if (id == null) return GRADIENTS[0];
  return GRADIENTS[Math.abs(Number(id)) % GRADIENTS.length];
}

export default function Avatar({
  nome,
  id,
  fotoUrl,
  corCustom,    // hex sólido (override do gradient)
  size = 36,
  title,
}) {
  const ini = iniciais(nome);
  const fontSize = Math.round(size * 0.36);
  let background;
  if (fotoUrl) {
    background = `url(${fotoUrl}) center/cover`;
  } else if (corCustom) {
    background = corCustom;
  } else {
    const [c1, c2] = gradientFromId(id);
    background = `linear-gradient(135deg, ${c1}, ${c2})`;
  }
  return (
    <div
      title={title || nome || ''}
      style={{
        width: size, height: size,
        borderRadius: '50%',
        background,
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 700,
        fontSize,
        flexShrink: 0,
        userSelect: 'none',
        boxShadow: 'inset 0 0 0 1px rgba(255,255,255,0.15)',
      }}>
      {!fotoUrl && ini}
    </div>
  );
}
